import { useState, useEffect } from 'react';
import { SCREEN } from 'scenes/common/types/screen';

export const useMedia = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    const updateMatches = () => {
      setMatches(mediaQuery.matches);
    };

    updateMatches();

    mediaQuery.addEventListener('change', updateMatches);

    return () => {
      mediaQuery.removeEventListener('change', updateMatches);
    };
  }, [query]);

  return matches;
};

export const useIsDesktop = () => {
  const isDesktop = useMedia(`(min-width: ${SCREEN.MEDIUM + 1}px)`);
  return isDesktop;
};

export const useIsLargeScreen = () => {
  const isLargeScreen = useMedia(`(min-width: ${SCREEN.LARGE}px)`);
  return isLargeScreen;
};
